import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "akabiz_recent_searches_v1";
const MAX_ITEMS = 10;

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x) => typeof x === "string" && x.trim().length > 0);
  } catch {
    return [];
  }
}

function writeStore(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    /* ignore quota / disabled storage */
  }
}

export function useRecentSearches() {
  const [recent, setRecent] = useState(() => readStore());

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setRecent(readStore());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const push = useCallback((query) => {
    const q = typeof query === "string" ? query.trim() : "";
    if (!q) return;
    setRecent((prev) => {
      const next = [q, ...prev.filter((x) => x !== q)].slice(0, MAX_ITEMS);
      writeStore(next);
      return next;
    });
  }, []);

  const remove = useCallback((query) => {
    setRecent((prev) => {
      const next = prev.filter((x) => x !== query);
      writeStore(next);
      return next;
    });
  }, []);

  const clear = useCallback(() => {
    writeStore([]);
    setRecent([]);
  }, []);

  return { recent, push, remove, clear };
}

export default useRecentSearches;
